import VehicleForm from '../../../components/vehicle/VehicleForm'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import CsvDependencies from '../../../components/vehicle/CsvDependencies'
import { useParams } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { getRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'
import ConnectorList from '../../../components/vehicle/connectors'
import ConnectorStore from '../../../components/vehicle/connectors/context/context'

const EditVehicle = () => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    getVehicleDetails()
  }, [])

  const getVehicleDetails = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Vehicle Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(`/api/vehicles/vehicle_details/${vehicle}/`)
    if (res?.msg) {
      setError(res?.msg)
    } else {
      setVehicleDetails(res)
      setError('')
    }
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList style={{ fontSize: '1.25rem' }}>
        <Tab>Vehicle Details</Tab>
        <Tab>CSV Dependencies</Tab>
        <Tab>Connectors</Tab>
      </TabList>
      <TabPanel>
        <div className="w-full bg-tracer-dark-blue text-white ">
          {error ? (
            error
          ) : (
            <VehicleForm
              vehicleDetails={vehicleDetails}
              setVehicleDetails={setVehicleDetails}
            />
          )}
        </div>
      </TabPanel>
      <TabPanel>
        <div className="w-full bg-tracer-dark-blue text-white block">
          {error ? (
            error
          ) : (
            <CsvDependencies
              vehicleDetails={vehicleDetails}
              setVehicleDetails={setVehicleDetails}
            />
          )}
        </div>
      </TabPanel>
      <TabPanel>
        <ConnectorStore>
          <ConnectorList />
        </ConnectorStore>
      </TabPanel>
    </Tabs>
  )
}

export default EditVehicle
